import {AxiosChatInstance, AxiosInstance} from "../api/AxiosInstance";

export const sendMessage = async (sendMsg) => {
  try {
    const response = await AxiosChatInstance.post("/api/signr/send", sendMsg);
    return response.data;
  } catch (error) {
    throw error?.response || "Failed sending message";
  }
};

export const receiveMessage = async (recMsg) => {
  try {
    const response = await AxiosChatInstance.post("/api/signr/rec", recMsg)
    return response.data
  } catch (error) {
    throw error?.response || "Failed sending message"
  }
};

export const receiveEmoji = async () => {
  try {
    const response = await AxiosInstance.get("/api/img/feed/icons")
    return response.data
  } catch (error) {
    throw error?.response || "Failed getting emojis"
  }
}

export const getMessages = async (IdUsuario, IdAmigo) => {
  try {
    const response = await AxiosChatInstance.get(`/api/redirec/msj?IdUsuario=${IdUsuario}&IdAmigo=${IdAmigo}`)
    return response.data
  } catch (error) {
    throw error?.response || "Failed getting messages"
  }
}

export const postSharePub = async (req) => {
  try {
    const response = await AxiosChatInstance.post("/api/pubs/comparte", req)
    return response.data
  } catch (error) {
    throw error?.response || "Failed sharing publication"
  }
}

// Reportar mensaje
export const reportMessage = async (req) => {
  try {
    const response = await AxiosChatInstance.post("/api/Reportar/chat/mensaje", req)
    return response.data
  } catch (error) {
    throw error?.response || "Failed reporting message"
  }
};

// Insertar/Actualizar/Eliminar reacción
export const saveReaction = async (req) => {
  try {
    const response = await AxiosChatInstance.post("/api/Insertar/reaccion-chat", req);
    return response.data;
  } catch (error) {
    throw error?.response || "Failed saving reaction";
  }
};

//Archivar chat

export const archiveChat = async (req) => {
  try {
    const response = await AxiosChatInstance.post("/api/archivar/chat", req)
    return response.data
  } catch (error) {
    throw error?.response || "Failed archiving chat"
  }
}

//Eliminar Chat

export const deleteChat = async  (req) => {
  try {
    const response = await AxiosChatInstance.post("/api/eliminar/chat", req)    
    return response.data
  } catch (error) {
    throw error?.response || "Failed deleting chat"
  }
}

//barra de Busqueda

export const searchFriend = async (req) =>{
  try {
    const response = await AxiosChatInstance.post("/api/buscador/chat-amigos", req)
    return response.data
  } catch (error) {
    throw error?.response || "failed searching friends"
    
  }
}
